import * as React from "react";

const LadleTrackSvg = (props: any) => (
	<svg
		width={359}
		height={166}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g filter="url(#a)">
			<rect x={16} y={16} width={326.618} height={133.457} rx={8} fill="#fff" />
			<path
				d="M45.062 93.22 64.067 61.2a3.523 3.523 0 0 0 .064-3.485c-1.307-2.396-4.724-2.46-6.12-.116L33.365 98.982a1.516 1.516 0 0 0 1.303 2.292H69.88l-4.349-7.313a1.516 1.516 0 0 0-1.303-.742H45.062Z"
				fill="url(#b)"
			/>
			<path
				d="m54.252 83.903 9.607-15.663c1.378-2.245 4.628-2.282 6.056-.069a3.577 3.577 0 0 1-.03 3.924l-3.053 4.579 15.022 24.6h-9.361l-9.797-17.416-2.438 3.809a3.545 3.545 0 0 1-2.985 1.634c-2.77 0-4.47-3.037-3.022-5.398Z"
				fill="url(#c)"
			/>
			<path
				d="M96.971 67.924h5.154V92.03h13.636v4.261h-18.79V67.924Zm28.98 28.976c-2.327 0-4.234-.609-5.723-1.826-1.488-1.245-2.232-2.909-2.232-4.992 0-2.164.704-3.855 2.111-5.073 1.407-1.217 3.382-1.826 5.925-1.826 2.462 0 4.586.5 6.371 1.502v-.528c0-1.38-.433-2.38-1.298-3.003-.839-.622-2.205-.933-4.099-.933-1.191 0-2.368.121-3.531.365-1.163.216-2.191.527-3.084.933v-4.018c.811-.378 1.894-.69 3.246-.933a22.898 22.898 0 0 1 3.978-.365c3.381 0 5.884.73 7.507 2.191 1.624 1.434 2.435 3.436 2.435 6.007v11.89h-4.829v-1.907a8.812 8.812 0 0 1-2.881 1.867c-1.056.433-2.354.65-3.896.65Zm1.258-3.734c1.136 0 2.164-.216 3.084-.649.92-.46 1.623-1.082 2.11-1.867V88.5c-1.488-1.056-3.192-1.583-5.113-1.583-2.733 0-4.099 1.055-4.099 3.165 0 1.028.338 1.8 1.015 2.313.703.514 1.704.772 3.003.772Zm24.477 3.734c-1.975 0-3.747-.42-5.316-1.258a9.561 9.561 0 0 1-3.653-3.612c-.865-1.57-1.298-3.382-1.298-5.438 0-2.03.433-3.828 1.298-5.397.893-1.57 2.111-2.787 3.653-3.653 1.569-.893 3.341-1.34 5.316-1.34 3.193 0 5.709.84 7.549 2.517V66.301h5.113v29.99h-4.951V94.02c-1.109 1.028-2.259 1.772-3.45 2.232-1.19.433-2.611.65-4.261.65Zm1.258-4.018c1.461 0 2.76-.392 3.896-1.177 1.136-.784 1.935-1.84 2.395-3.165v-3.937a5.95 5.95 0 0 0-2.395-3.165c-1.136-.812-2.435-1.217-3.896-1.217-1.84 0-3.355.595-4.545 1.785-1.191 1.19-1.786 2.72-1.786 4.586 0 1.867.595 3.382 1.786 4.545 1.19 1.164 2.705 1.745 4.545 1.745Zm16.275-26.581h5.114v29.99h-5.114v-29.99Zm20.945 30.6c-3.625 0-6.493-.907-8.604-2.72-2.11-1.813-3.165-4.342-3.165-7.589 0-3.192.933-5.722 2.8-7.589 1.867-1.867 4.532-2.8 7.995-2.8 2.273 0 4.207.433 5.803 1.298 1.624.866 2.841 2.057 3.653 3.572.811 1.488 1.217 3.192 1.217 5.113v2.354h-16.598c.352 2.895 2.868 4.342 7.548 4.342 1.245 0 2.516-.108 3.815-.324 1.299-.217 2.435-.514 3.409-.893V95.6c-.92.38-2.11.69-3.571.934a25.655 25.655 0 0 1-4.302.365Zm4.87-11.851c-.054-1.542-.609-2.733-1.664-3.571-1.028-.84-2.449-1.258-4.261-1.258-1.786 0-3.193.432-4.221 1.298-1.028.866-1.569 2.043-1.623 3.53h11.769Zm11.998-12.865h-8.563v-4.261h22.28v4.261h-8.563v24.106h-5.154V72.185Zm13.907 4.627h4.951v3.124c.784-1.055 1.894-1.84 3.328-2.353 1.46-.514 3.124-.771 4.991-.771v3.896c-1.975 0-3.693.31-5.154.933-1.434.595-2.435 1.542-3.003 2.84v11.81h-5.113v-19.48ZM242.784 96.9c-2.326 0-4.234-.609-5.722-1.826-1.488-1.245-2.232-2.909-2.232-4.992 0-2.164.704-3.855 2.111-5.073 1.406-1.217 3.381-1.826 5.925-1.826 2.462 0 4.586.5 6.371 1.502v-.528c0-1.38-.433-2.38-1.299-3.003-.838-.622-2.204-.933-4.098-.933-1.191 0-2.368.121-3.531.365-1.163.216-2.192.527-3.084.933v-4.018c.811-.378 1.894-.69 3.246-.933a22.896 22.896 0 0 1 3.977-.365c3.382 0 5.885.73 7.508 2.191 1.623 1.434 2.435 3.436 2.435 6.007v11.89h-4.829v-1.907a8.806 8.806 0 0 1-2.882 1.867c-1.055.433-2.353.65-3.896.65Zm1.259-3.734c1.136 0 2.164-.216 3.084-.649.92-.46 1.623-1.082 2.11-1.867V88.5c-1.488-1.056-3.192-1.583-5.113-1.583-2.733 0-4.099 1.055-4.099 3.165 0 1.028.338 1.8 1.014 2.313.704.514 1.705.772 3.004.772Zm24.821 3.734c-2.273 0-4.275-.406-6.007-1.217-1.704-.812-3.03-1.989-3.977-3.531-.947-1.542-1.42-3.395-1.42-5.56 0-2.164.473-4.018 1.42-5.56.974-1.569 2.314-2.76 4.018-3.571 1.732-.839 3.747-1.258 6.047-1.258 3.03 0 5.451.595 7.264 1.785v4.1c-1.758-1.245-4.004-1.867-6.737-1.867-2.083 0-3.747.527-4.991 1.582-1.218 1.028-1.827 2.625-1.827 4.79 0 2.136.609 3.72 1.827 4.747 1.244 1.028 2.881 1.542 4.91 1.542 2.733 0 5.087-.649 7.062-1.948v4.059c-.974.649-2.084 1.123-3.328 1.42-1.218.325-2.638.487-4.261.487Zm11.641-30.6h5.113v19.075l7.752-8.563h6.006l-8.685 9.537 9.659 9.942h-6.006l-8.726-9.009v9.01h-5.113V66.3Z"
				fill="url(#d)"
			/>
		</g>
		<defs>
			<linearGradient
				id="b"
				x1={43.915}
				y1={89.367}
				x2={59.279}
				y2={56.349}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#237CDF" />
				<stop offset={1} stopColor="#61BE61" />
			</linearGradient>
			<linearGradient
				id="c"
				x1={43.915}
				y1={89.367}
				x2={59.279}
				y2={56.349}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#237CDF" />
				<stop offset={1} stopColor="#61BE61" />
			</linearGradient>
			<linearGradient
				id="d"
				x1={150.002}
				y1={98.367}
				x2={156.109}
				y2={49.207}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#237CDF" />
				<stop offset={1} stopColor="#61BE61" />
			</linearGradient>
			<filter
				id="a"
				x={0}
				y={0}
				width={358.618}
				height={165.457}
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation={8} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0.216667 0 0 0 0 0.216667 0 0 0 0 0.216667 0 0 0 0.08 0" />
				<feBlend
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1839_68452"
				/>
				<feBlend
					in="SourceGraphic"
					in2="effect1_dropShadow_1839_68452"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
);

export default LadleTrackSvg;
